import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {ErrorCorrectReportData} from "./error-correct-report.data";

@Injectable()
export class ErrorCorrectReportModel extends ReportModel<ErrorCorrectReportData> {
    constructor(injector: Injector) {
        super(injector, ErrorCorrectReportData);
    }
}
